'use client';

import React from 'react';
import { StyledPlatformHero } from './contentPageHero.styles';
import cn from 'classnames';
import { Header } from '../header/header.comp';
import { CSSProperties } from 'styled-components';

interface IContentPageHeroProps {
	title: string;
	subtitle: string;
	text?: string;
	isFullPage?: boolean;
	style?: CSSProperties;
}

export const ContentPageHero = ({
	subtitle,
	title,
	text,
	isFullPage,
	style
}: IContentPageHeroProps) => {
	return (
		<StyledPlatformHero
			style={style}
			className={cn({
				'full-width': isFullPage,
			})}
		>
			<div className={cn('hero-wrapper')}>
				{title && <h1>{title}</h1>}
				{subtitle && <h2>{subtitle}</h2>}
				{text && <p>{text}</p>}
			</div>
		</StyledPlatformHero>
	);
};
